import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';

const getSupplierList = async (searchPhrase: any, pageSize: any, currentPage: any, ancillaryFilters: any, sortField: any, sortDirection: any, toast = null) => {

    let params: Record<string, any> = {
      pageSize,
      pageIndex: currentPage - 1,
      searchPhrase,
      SortExpression: sortField,
      SortDirection: sortDirection,
      PopulateList: false,
    };

    if (ancillaryFilters) {
        params = {
            ...params,
            IncludeClosed: ancillaryFilters["IncludeDisabled"],
        };
    }

    return await Fetch.post({
        url: `/Supplier/GetSuppliers`,
        params,
        toastCtx: toast
    });
};

const getSupplierAncillaryFilters = () => {
    const includeDisabledFilter = [{
        type: Enums.ControlType.Switch,
        label: 'Include disabled suppliers',
    }];
    return {
        IncludeDisabled: includeDisabledFilter,
    };
};

const getAllSuppliers = async () => {
    return await Fetch.get({
        url: `/Supplier/IncludeDisabled/true`
    });
};

const getTabCounts = async (supplierID: any) => {
    const countRequest = await Fetch.get({
        url: `/Supplier/GetCounts?id=${supplierID}`,
    });

    const result = countRequest.Results;
    let attachmentCount = result.find((x: any) => x.Key == 'Attachments');
    let communicationCount = result.find((x: any) => x.Key == 'Communication');
    let contactCount = result.find((x: any) => x.Key == 'Contacts');
    let locationCount = result.find((x: any) => x.Key == 'Locations');
    let purchaseOrderCount = result.find((x: any) => x.Key == 'PurchaseOrders');

    return {
        attachmentCount: attachmentCount ? attachmentCount.Value : 0,
        communicationCount: communicationCount ? communicationCount.Value : 0,
        contactCount: contactCount ? contactCount.Value : 0,
        locationCount: locationCount ? locationCount.Value : 0,
        purchaseOrderCount: purchaseOrderCount ? purchaseOrderCount.Value : 0,
    };
};

const validate = (supplier: any) => {
    let validationItems = [
        { key: 'Name', value: supplier.Name, required: true, type: Enums.ControlType.Text },
        { key: 'EmailAddress', value: supplier.EmailAddress, type: Enums.ControlType.Email },
        { key: 'ContactNumber', value: supplier.ContactNumber, type: Enums.ControlType.ContactNumber },
    ];

    return Helper.validateInputs(validationItems);
};

const createSupplier = async (supplier: any, toast = null) => {
    return await Fetch.post({
        url: `/Supplier`,
        params: supplier,
        toastCtx: toast,
    });
};

const editSupplier = async (supplier: any, toast = null) => {
    return await Fetch.put({
        url: `/Supplier`,
        params: supplier,
        toastCtx: toast,
    });
};

const getSupplier = async (id: any) => {
    return await Fetch.get({
        url: `/Supplier/${id}`,
        params: {}
    });
}

export default {
    getSupplierList,
    getSupplierAncillaryFilters,
    getAllSuppliers,
    getTabCounts,
    validate,
    createSupplier,
    editSupplier,
    getSupplier
};
